/*
 * @Author: ltm
 * @LastEditors: ltm
 * @Descripttion:
 * @params:
 * @Date: 2023-07-16 20:59:14
 * @LastEditTime: 2023-07-16 21:51:56
 */
import axios from 'axios'
import Message from '@t/utils/a-message'

// create an axios instance
const service = axios.create({
  // 后端接口统一走本机同源 /yljx/*（nginx 8090 已代理到 127.0.0.1:8080），避免跨域。
  // 原硬编码 https://www.txky-zg.com/ 域名不指向 124，已改为同源相对路径。
  baseURL: '', // url = base url + request url
  timeout: 30000 // 30秒钟
})

// request interceptor
service.interceptors.request.use(
  config =>
    // do something before request is sent
    // if (token) {
    // }
    config
  ,
  error =>
    // do something with request error
    Promise.reject(error)

)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    // console.log('response---', response); // for debug
    const res = response.data
    return res
  },
  (error) => {
    console.log('error :>> ', error)
    // Message({
    //   message,
    //   type: 'error',
    //   duration: 5 * 1000,
    // });
    return Promise.reject(error)
  }
)

export default service

export function simpleRequest (url, method, params) {
  return service.request({
    url,
    method,
    [method === 'get' ? 'params' : 'data']: params
    // ...extConfig,
  })
}
